import { DEFAULT_SERIES_COLORS } from '@cplug/design-system/components'
import { invertPrimaryPalette, type PrimaryPalette } from '~/domain/shared/branding/models/PrimaryPalette'

const BRAND_THEME_STYLE_ID = 'brand-primary-palette'

function chartTokensCss (primaryColor: string): string {
  const series = [
    primaryColor,
    DEFAULT_SERIES_COLORS[1],
    DEFAULT_SERIES_COLORS[2],
    DEFAULT_SERIES_COLORS[3],
    DEFAULT_SERIES_COLORS[4]
  ]

  return series
    .map((color, index) => `  --chart-${index + 1}:${color ?? primaryColor};`)
    .join('\n')
}

function paletteToCssBlock (selector: string, palette: PrimaryPalette): string {
  const scale = ([50, 100, 200, 300, 400, 500, 600, 700, 800, 900, 950] as const)
    .map(step => `  --primary-${step}:${palette[step]};`)
    .join('\n')

  return `${selector}{
${scale}
  --primary:${palette[500]};
  --primary-foreground:#ffffff;
  --ring:${palette[500]};
${chartTokensCss(palette[500])}
}`
}

export function applyBrandPrimaryPalette (palette: PrimaryPalette): void {
  if (typeof document === 'undefined') {
    return
  }

  const darkPalette = invertPrimaryPalette(palette)
  const css = [
    paletteToCssBlock(':root', palette),
    paletteToCssBlock('.dark', darkPalette)
  ].join('\n')

  let styleElement = document.getElementById(BRAND_THEME_STYLE_ID) as HTMLStyleElement | null

  if (!styleElement) {
    styleElement = document.createElement('style')
    styleElement.id = BRAND_THEME_STYLE_ID
    document.head.appendChild(styleElement)
  }

  styleElement.textContent = css
}
